<template lang="pug">
    d2-container
            el-form(:inline='true', :model='form', size='mini',label-width="75px",  @keyup.enter.native='getDataList()')
              el-row
                el-col(:span='5')
                  el-form-item(label="场馆名称:")
                      el-input(v-model='form.name', placeholder='场馆名称', clearable='',style="width:170px;")
                el-col(:span='5')
                  el-form-item(label="站点:" label-width="72px" )
                      el-input(v-model='form.area', placeholder='站点', clearable='',style="width:170px;")
                el-col(:span='9')
                  el-form-item(label="地区:" label-width="72px" )
                    el-row(style='width:360px')
                      el-col(style="width:120px;")
                        el-select(v-model="form.proviceId" placeholder="请选择" @change="changeProvice"  clearable)
                          el-option(v-for="(item,index) in proviceList" :key="index" :label="item.name" :value="item.proviceId")
                      el-col(style="width:30px;" class="line") &nbsp;&nbsp;省&nbsp;&nbsp;
                      el-col(style="width:120px;")
                        el-select(v-model="form.cityId" placeholder="请选择" clearable)
                          el-option(v-for="(item,index) in cityList" :key="index" :label="item.cityname" :value="item.cityId")
                      el-col(style="width:30px;") &nbsp;&nbsp;市&nbsp;
                el-col(:span='5')
                  el-form-item(label="主办方:" label-width="72px")
                    el-select(v-model="form.orgId" placeholder="请选择" filterable clearable style="width:170px;")
                      el-option(v-for="(item,index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
              el-row(style="padding-bottom:15px;")
               el-col(:span="24")
                    el-button(v-if="isAuth('operation:place:save')", type='primary', @click='addOrUpdateHandle()') 新增
                    el-button(v-if="isAuth('operation:place:delete')", type='danger', @click='deleteHandle()', :disabled='dataListSelections.length <= 0') 删除
                    el-button(style="float:right;" type='primary',icon='el-icon-search', @click='getDataList()' ) 查询
            el-table(:data='dataList', border, v-loading='dataListLoading', @selection-change='selectionChangeHandle', style='width: 100%;')
                el-table-column(type="selection" width="55")
                el-table-column(prop='name', header-align='center', align='center', label='场馆名称')
                el-table-column(prop='area', header-align='center', align='center', label='站点')
                el-table-column(prop='proviceName', header-align='center', align='center', label='省')
                el-table-column(prop='cityNames', header-align='center', align='center', label='市')
                el-table-column(prop='orgName', header-align='center', align='center', label='主办方')
                el-table-column(prop='address', header-align='center', align='center', label='地址')
                el-table-column(prop='tel', header-align='center', align='center', label='联系电话')
                el-table-column(prop='hided', header-align='center', align='center', label='是否展示')
                  template(slot-scope='scope')
                    el-switch(v-model="scope.row.hided === 0" @change="changeHideStatus(scope.row.id, scope.row.hided)")
                el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" v-if="isAuth('operation:place:info')"  @click="viewHandle(scope.row.id)") 查看详情
                                el-menu-item(index="1-2" v-if="isAuth('operation:place:update')"  @click="addOrUpdateHandle(scope.row.id)") 修改
            el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
            add-or-update(v-if='addOrUpdateVisible', ref='addOrUpdate', @refreshdatalist='getDataList')
            view-info(v-if='viewVisible', ref='viewInfo', @refreshdatalist='getDataList')
            demo(v-if='demoov', ref='demoo')
</template>
<script>
import AddOrUpdate from './place-add-or-update'
import ViewInfo from './view'
export default {
  name: 'place',
  data () {
    return {
      isCollapse: true,
      form: {
        name: '',
        area: '',
        proviceName: '',
        cityName: '',
        orgName: '',
        proviceId: '',
        cityId: '',
        orgId: ''
      },
      proviceList: [],
      cityList: [],
      sysOrgList: [],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      viewVisible: false,

      demoov: false
    }
  },
  components: {
    AddOrUpdate,
    ViewInfo
  },
  created () {
    this.getDataList()
    this.initProvice()
    this.changeOrg()
  },
  methods: {
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/pbPlaces/list'),
        method: 'get',
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize,
          name: this.form.name,
          area: this.form.area,
          proviceId: this.form.proviceId,
          cityId: this.form.cityId,
          orgId: this.form.orgId
        })
      }).then(data => {
        if (data && data.code === 0) {
          this.dataList = data.page.records
          this.totalPage = data.page.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    handleClose () {},
    handleOpen () {},
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    viewHandle (id) {
      this.viewVisible = true
      this.$nextTick(() => {
        this.$refs.viewInfo.init1(id)
      })
    },
    initProvice () {
      this.$http({
        url: this.$http.adornUrl('/dicProvince/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then(data => {
        this.proviceList = data && data.code === 0 ? data.list : []
      })
    },
    changeProvice () {
      this.cityList = []
      this.form.cityId = ''
      this.$http({
        url: this.$http.adornUrl('/dicProvinceCity/list'),
        method: 'get',
        params: this.$http.adornParams({
          proviceId: this.form.proviceId
        })
      }).then(data => {
        this.cityList = data && data.code === 0 ? data.list : []
      })
    },
    changeOrg () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams({
          cityId: '',
          proviceId: ''
        })
      }).then(data => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    // 删除
    deleteHandle (id) {
      var ids = id
        ? [id]
        : this.dataListSelections.map(item => {
            return item.id
          })
      this.$confirm(`是否删除场馆?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl('/pbPlaces/delete'),
            method: 'post',
            data: ids
          }).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
        .catch(() => {})
    },
    changeHideStatus (placeId, hideStatus) {
      this.$http({
        url: this.$http.adornUrl('/pbPlaces/updateHideStatus'),
        method: 'get',
        params: this.$http.adornParams({
          placeId,
          hideStatus: hideStatus === 0 ? 1 : 0
        })
      }).then(data => {
        if (data && data.code === 0) {
          this.$message({
            message: `${hideStatus === 0 ? '隐藏' : '展示'}成功`,
            type: 'success'
          })
          this.getDataList()
        } else {
          this.$message.error(data.msg)
        }
      })
    }
  }
}
</script>
<style>
  /* 操作三点 菜单样式 */
 @import '../../css/opr3dot.css';
</style>>
